// extracted by mini-css-extract-plugin
export default {"burger_img":"ProductHamburger_burger_img__VTkj+"};